module.exports = __webpack_public_path__ + "static/media/slide-mobile (2).98a7cdd0.jpg";